import { createSlice } from "@reduxjs/toolkit";
import { calculateClaim } from "../../reducer/claimsCalculate/claimsCalculateReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const calculateClaimSlice = createSlice({
  name: "calculateClaim",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(calculateClaim.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(calculateClaim.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(calculateClaim.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default calculateClaimSlice.reducer;
